
import path from 'path'
import { defineComponent, PropType, reactive, toRefs, ref } from 'vue'
import { isExternal } from '@/utils/validate'
import Item from './Item.vue'
import AppLink from './Link.vue'
import useFixiOSBug from '../../hooks/useFixiOSBug'

interface RouteItem {
  path: string
  children?: RouteItem[]
  hidden?: boolean
  alwaysShow?: boolean
  meta?: {
    icon?: string
    title: string
  }
  query?: string
  noShowingChildren?: boolean
}

export default defineComponent({
  name: 'SidebarItem',
  components: { Item, AppLink },
  props: {
    // 路由对象
    item: {
      type: Object as PropType<RouteItem>,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const state = reactive({
      onlyOneChild: null as RouteItem | null
    })
    
    // 使用Composition API代替mixin
    const { subMenu } = useFixiOSBug()
    
    const hasOneShowingChild = (children: RouteItem[] = [], parent: RouteItem) => {
      if (!children) {
        children = []
      }
      
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // 临时设置(当只有一个显示子路由时使用)
          state.onlyOneChild = item
          return true
        }
      })

      // 当只有一个子路由时，默认展示子路由
      if (showingChildren.length === 1) {
        return true
      }

      // 如果没有子路由显示，则显示父路由
      if (showingChildren.length === 0) {
        state.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    }
    
    const resolvePath = (routePath: string, routeQuery?: string) => {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(props.basePath)) {
        return props.basePath
      }
      if (routeQuery) {
        let query = JSON.parse(routeQuery)
        return { path: path.resolve(props.basePath, routePath), query: query }
      }
      return path.resolve(props.basePath, routePath)
    }
    
    return {
      ...toRefs(state),
      subMenu,
      hasOneShowingChild,
      resolvePath
    }
  }
})
